<template lang="html">
  <section class="overview">
    <overview-edit-name
      class="edit-name"
      id="dc-name-edit"
      :uuid="distributionChannelDetail.uuid"
      :name="distributionChannelDetail.name"
    />
    <div class="overview-details">
      <div class="row-detail">
        <div class="description">
          {{ $t("publishedWidgets") }}
        </div>
        <div class="totals">
          <div v-if="displayLoader" class="loader"></div>
          <div v-else>
            {{ distributionChannelDetail.publishedWidgets }}
          </div>
        </div>
      </div>
      <div class="row-detail">
        <div class="description">
          {{ $t("unpublishedWidgetVersions") }}
        </div>
        <div class="totals">
          <div v-if="displayLoader" class="loader"></div>
          <div v-else>
            {{ distributionChannelDetail.unpublishedWidgets }}
          </div>
        </div>
      </div>
      <div class="row-detail">
        <div class="description">
          {{ $t("customerDomainsFullAccess") }}
        </div>
        <div class="totals">
          <div v-if="displayLoader" class="loader"></div>
          <div v-else>
            {{ distributionChannelDetail.fullAccessCustomerDomains }}
          </div>
        </div>
      </div>
      <div class="row-detail">
        <div class="description">
          {{ $t("customerDomainsPartialAccess") }}
        </div>
        <div class="totals">
          <div v-if="displayLoader" class="loader"></div>
          <div v-else>
            {{ distributionChannelDetail.partialAccessCustomerDomains }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
  import { MUTATION_NAME, TOAST_OPTIONS } from "@/static/global-variables";
  import OverviewEditName from "@/components/custom-display-elements/tabs/parts/OverviewEditName";
  import DistributionChannelsService from "@/services/distributionChannelsService";

  export default  {
    name: "overview",
    components: {
      OverviewEditName
    },
    data () {
      return {
        displayLoader: false
      }
    },
    computed: {
      messages() {
        return this.$store.state.messages;
      },
      distributionChannelDetail() {
        return this.$store.getters[MUTATION_NAME.DISTRIBUTION_CHANNEL_DETAIL] || {};
      },
      isRefreshOverview() {
        return this.$store.getters[MUTATION_NAME.REFRESH_OVERVIEW];
      }
    },
    mounted () {
      if(this.isRefreshOverview) {
        this.displayLoader = true;
        DistributionChannelsService.distributionChannelDetails(this.$route.params.uuid)
        .then(() => {
          this.$store.commit(MUTATION_NAME.REFRESH_OVERVIEW, false);
        })
        .catch(e => {
          this.$bvToast.toast(this.getMessageText(this.messages.ERROR_WHILE_LOADING), TOAST_OPTIONS.bottomCenter);
          console.error(e);
        })
        .finally(() => {
          this.displayLoader = false;
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  .overview {
    box-sizing: border-box;
    padding: 1rem;
    .overview-details {
      max-width: fit-content;
      min-width: 40rem;
      .row-detail {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid var(--LINE_GREY);
        color: var(--DEFAULT_TEXT_BLACK);
        font-size: 0.9rem;
        line-height: 1.25;
        padding: 0.7rem;
        .loader {
          height: 1rem;
          width: 1rem;
          margin: 0;
        }
        .description {
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .totals {
          padding-left: 3rem;
        }
      }
    }
    @media screen and (max-width: 600px) {
      .overview-details {
        min-width: 29rem;
      }
    }
    .edit-name {
      font-size: 1.5rem;
      padding: 0.5rem;
      min-height: 3.21rem;
    }
  }
</style>
